import { UnwrapPromise } from "@prisma/client";
import { LoaderFunction, Outlet } from "remix";
import { BreadcrumbLink } from "~/components/Breadcrumbs";
import { db } from "~/utils/db.server";
import { requireFestival } from "~/utils/festival.server";
import { getUserId } from "~/utils/session.server";

export interface LoaderData {
  events: UnwrapPromise<ReturnType<typeof loadEvents>>;
  isLoggedIn: boolean;
}

function loadEvents(festivalId: string) {
  return db.event.findMany({
    where: { festivalId: festivalId },
    include: { categories: true },
    orderBy: [
      {
        from: "asc",
      },
      {
        title: "asc",
      },
    ],
  });
}

export const loader: LoaderFunction = async ({
  request,
  params,
}): Promise<LoaderData> => {
  const [festival, userId] = await Promise.all([
    requireFestival(params.festivalSlug),
    getUserId(request),
  ]);

  const events = await loadEvents(festival.id);

  return {
    events,
    isLoggedIn: userId !== null,
  };
};

export const handle = {
  breadcrumb: ({ params }: { params: Record<string, string> }) => {
    return (
      <BreadcrumbLink to={`/${params.festivalSlug}/events`}>
        Kalender
      </BreadcrumbLink>
    );
  },
};

export default function Events() {
  return <Outlet />;
}
